import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
// import { Link } from 'react-router-dom';
import LoadingOverlay from '../loading/loading';
import service from '../../services/service';
import './style.css';

const Destination = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchHotels();
    }, []);

    const fetchHotels = async () => {
        setLoading(true);
        try {
            const response = await service.view('hotels/list');
            if (response && !response.success) {
                toast.error(response.message + ": " + response.error);
                return;
            } else {
                if (response && response.success) {
                    setData(response.data.topHotels || []);
                }
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    // const ClickHandler = () => {
    //     window.scrollTo(10, 0);
    // };

    const renderHotelItem = (hotel, index, image) => {
        if (!hotel) return null;
        return (
            <div className="destination-item" key={index}>
                <div className="destination-img">
                    <img style={{ width: '412px', height: '462px', objectFit: 'cover' }} src={image} alt={hotel.name} />
                </div>
                <div className="destination-content">
                    <div className="content-left">
                        {/* <h5><Link onClick={ClickHandler} to={`/room-single/${hotel._id}`}>{hotel.name}</Link></h5> */}
                        <h5>{hotel.name}</h5>
                        <small>{hotel.address}</small>
                    </div>
                    <div className="content-right">
                        <h5>₹ {hotel.pricePerNight}</h5>
                        <span>Per Night</span>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="destination-area section-padding">
            {loading && <LoadingOverlay />}
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <div className="destination-text">
                            <div className="wpo-section-title">
                                <span>Top Rated Hotels </span>
                                <h2>Choose Your Stay </h2>
                            </div>
                            <p>
                                Discover the finest accommodations handpicked for exceptional comfort, luxury, and value. Whether you’re planning a serene getaway, a business trip, or a family vacation, we’ve curated the top-rated hotels worldwide to make your stay unforgettable.
                            </p>
                            {/* <div className="btns">
                                <Link onClick={ClickHandler} to="/hotels" className="theme-btn-s2">Discover More</Link>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="destination-wrap">
                            <div className="row">
                                <div className="col-md-6 col-sm-6 custom-grid">
                                    <div className="destination-left">
                                        {data?.[0]?.images?.[1] && renderHotelItem(data[0], 0, data[0]?.images[1])}
                                        {data?.[1]?.images?.[4] && renderHotelItem(data[1], 1, data[1]?.images[4])}
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6 custom-grid">
                                    <div className="destination-right">
                                        {data?.[2]?.images?.[3] && renderHotelItem(data[2], 2, data[2]?.images[3])}
                                        {data?.[3]?.images?.[0] && renderHotelItem(data[3], 3, data[3]?.images[0])}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Destination;
